import { useEffect, useRef, useState } from 'react'

interface AnimatedBarProps {
  width: number
  color: string
  delay: number
}

export function AnimatedBar({ width, color, delay }: AnimatedBarProps) {
  const [w, setW] = useState(0)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        const e = entries[0]
        if (e?.isIntersecting) {
          setTimeout(() => setW(width), delay)
        }
      },
      { threshold: 0.3 },
    )
    if (ref.current) obs.observe(ref.current)
    return () => obs.disconnect()
  }, [width, delay])

  return (
    <div
      ref={ref}
      style={{
        height: 8, borderRadius: 4, background: '#EDE9E4',
        overflow: 'hidden', width: '100%',
      }}
    >
      <div
        style={{
          height: '100%', borderRadius: 4, background: color,
          width: `${w}%`,
          transition: 'width 1.2s cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      />
    </div>
  )
}
